/* global MEDIA_ROOT */
/* eslint-disable no-underscore-dangle */

import React, { PropTypes, PureComponent } from 'react';

import { withAsyncScript } from '../AsyncScriptWrapper/AsyncScriptWrapper.react';

import { select } from '../../base-styles/forms.module.css';

import styles from './styles.css'; // eslint-disable-line no-unused-vars
import { download, elevationInfo } from './styles.module.css';

class CourseMaps extends PureComponent {
  constructor(props) {
    super(props);
    this.courses = props.courses;
    this.state = {
      currentIndex: 0,
      gain: undefined,
      max: undefined,
      start: undefined,
    };
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    const { Leaflet } = this.props;
    // Create map
    this.map = new Leaflet.Map('map', { attributionControl: false, dragging: !Leaflet.Browser.mobile, touchZoom: true, tap: !Leaflet.Browser.mobile });
    this.tileLayer = new Leaflet.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
    this.map.addLayer(this.tileLayer);

    // Create elevation graphs
    this.elevationControls = this.courses.map(() => {
      const elevationControl = Leaflet.control.elevation({
        margins: {
          top: 10,
          right: 40,
          bottom: 30,
          left: 40,
        },
        width: document.getElementById('map').offsetWidth,
      });
      // Graph should be outside of the map component
      const elevationDOMElement = elevationControl.onAdd(this.map);
      elevationDOMElement.className += ' leaflet-container leaflet-control';
      elevationDOMElement.style.display = 'none';
      // Append to different parent
      document.getElementById('elevation').appendChild(elevationDOMElement);
      return elevationControl;
    });

    // Create GPX layers
    const firstGpx = this.courses[0].gpx;
    this.gpxRoutes = this.courses.map((course, index) =>
      new Leaflet.GPX(course.gpx, {
        async: true,
        marker_options: {
          startIcon: Leaflet.icon({
            iconUrl: `${MEDIA_ROOT}/icons/icn_start.svg`,
            iconRetinaUrl: `${MEDIA_ROOT}/icons/icn_start.svg`,
            iconSize: [23, 36],
            iconAnchor: [0, 36],
          }),
          endIcon: Leaflet.icon({
            iconUrl: `${MEDIA_ROOT}/icons/icn_finish.svg`,
            iconRetinaUrl: `${MEDIA_ROOT}/icons/icn_finish.svg`,
            iconSize: [23, 36],
            iconAnchor: [23, 36],
          }),
        },
        polyline_options: {
          color: '#ff0040',
          opacity: 1,
          weight: 3,
        },
      })
        .on('addline', (event) => {
          this.elevationControls[index].addData(event.line);
        })
        .on('loaded', (event) => {
          if (event.target._gpx === firstGpx) {
            this.showCourse(firstGpx);
          }
        }),
    );
  };

  showCourse = (gpx) => {
    // Remove existing route if set
    if (this.state.currentIndex > -1) {
      this.map.removeLayer(this.gpxRoutes[this.state.currentIndex]);
      this.elevationControls[this.state.currentIndex]._container.style.display = 'none';
      // this.map.removeLayer();
    }

    // Find new route
    const currentIndex = this.courses.map(c => c.gpx).indexOf(gpx);
    if (currentIndex > -1) {
      //
      const gpxRoute = this.gpxRoutes[currentIndex];
      this.map.addLayer(gpxRoute);
      this.map.fitBounds(gpxRoute.getBounds());

      //
      const elevation = this.elevationControls[currentIndex];
      if (gpxRoute.get_elevation_gain()) elevation._container.style.display = 'block';

      this.setState({
        currentIndex,
        gain: gpxRoute.get_elevation_gain(),
        max: gpxRoute.get_elevation_max(),
        // Start elevation isn't available from a public method
        start: gpxRoute._info.elevation._points[0][1],
      });
    }
  };

  render() {
    const { showReliveLink } = this.props;
    const { gain, start, max, currentIndex } = this.state;
    const currentGPX = this.courses[currentIndex].gpx;
    return (
      <div>
        {this.courses.length > 1 && (
          <select
            onChange={event => this.showCourse(event.target.value)}
            style={{ marginBottom: 30, maxWidth: 282 }}
            className={select}
          >
            {this.courses.map(course => (
              <option key={`${course.title}-${course.gpx}`} value={course.gpx}>
                {course.title}
              </option>
            ))}
          </select>
        )}
        <div id="map" style={{ width: '100%', height: 420, margin: 0 }} />
        <div id="elevation" />
        {gain > 0 && (
        <ul className={elevationInfo}>
          <li>
            <h4>{'Elevation gain'}</h4>
            <span>{gain ? `${gain.toFixed(1)}m` : '—'}</span>
          </li>
          <li>
            <h4>{'Start elevation'}</h4>
            <span>{start ? `${start.toFixed(1)}m` : '—'}</span>
          </li>
          <li>
            <h4>{'Max elevation'}</h4>
            <span>{max ? `${max.toFixed(1)}m` : '—'}</span>
          </li>
          {(currentGPX || showReliveLink) && (
            <li className={download}>
              {currentGPX && (
                <h4>
                  <div>
                    <a href={currentGPX} download>
                      {'Export GPX file'}
                    </a>
                  </div>
                </h4>
              )}
              {showReliveLink && (
                <h4>
                  <div>
                    <a href="#relive-video">{'View 3D flyover by Relive'}</a>
                  </div>
                </h4>
              )}
            </li>
          )}
        </ul>)}
      </div>
    );
  }
}

CourseMaps.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      gpx: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  Leaflet: PropTypes.shape().isRequired,
  showReliveLink: PropTypes.bool,
};

CourseMaps.defaultProps = {
  showReliveLink: false,
};

// Configuration of async script requirement
const asyncScriptProps = {
  // ID given to script tag in index
  id: 'leaflet',
  // Global variable name when ready
  global: 'L',
  // Name to deliver global as prop (ensure loaded scope)
  propName: 'Leaflet',
};

// Wrap with async script loader, which adds global object as prop when ready
const CourseMapsWithAsync = withAsyncScript(CourseMaps, asyncScriptProps);

export default CourseMapsWithAsync;



// WEBPACK FOOTER //
// ./app/src/components/CourseMaps/index.jsx